import {
  Bot,
  ClipboardList,
  CreditCard,
  FileQuestion,
  Gauge,
  Library,
  type LucideIcon,
  Settings,
  ShieldCheck,
  ShoppingBag,
  Users,
} from 'lucide-react';

import type { Seccion } from '@/auth/queries';

/**
 * Menú lateral. Cada grupo corresponde a una sección de permisos (plan §3.4): si el staff no la
 * tiene, el grupo no aparece. Los ítems con `pronto` son módulos de fases siguientes.
 */
export interface ItemMenu {
  etiqueta: string;
  ruta: string;
  pronto?: boolean;
}

export interface GrupoMenu {
  etiqueta: string;
  icono: LucideIcon;
  seccion?: Seccion;
  items: ItemMenu[];
}

export const menu: GrupoMenu[] = [
  { etiqueta: 'Inicio', icono: Gauge, items: [{ etiqueta: 'Inicio', ruta: '/' }] },
  {
    etiqueta: 'Alumnos',
    icono: Users,
    seccion: 'alumnos',
    items: [
      { etiqueta: 'Directorio', ruta: '/alumnos' },
      { etiqueta: 'Por licencia', ruta: '/alumnos/por-licencia' },
      { etiqueta: 'Suspendidos', ruta: '/alumnos?status=suspended' },
      { etiqueta: 'Bloqueados', ruta: '/alumnos?status=blocked' },
    ],
  },
  {
    etiqueta: 'Tienda',
    icono: ShoppingBag,
    seccion: 'tienda',
    items: [
      { etiqueta: 'Licencias', ruta: '/tienda/licencias' },
      { etiqueta: 'Cupones y promociones', ruta: '/tienda/cupones' },
      { etiqueta: 'Becas', ruta: '/tienda/becas' },
      { etiqueta: 'Compras en equipo', ruta: '/tienda/equipos' },
    ],
  },
  {
    etiqueta: 'Pagos',
    icono: CreditCard,
    seccion: 'pagos',
    items: [{ etiqueta: 'Reporte de pagos', ruta: '/pagos' }],
  },
  {
    etiqueta: 'Contenido',
    icono: Library,
    seccion: 'contenido',
    items: [
      { etiqueta: 'Biblioteca', ruta: '/contenido' },
      { etiqueta: 'Contenido × licencia', ruta: '/contenido/matriz' },
      { etiqueta: 'Clases', ruta: '/contenido/clases' },
      { etiqueta: 'Presentaciones', ruta: '/contenido?type=presentacion' },
      { etiqueta: 'Manuales', ruta: '/contenido/manuales' },
      { etiqueta: 'Resúmenes GPC', ruta: '/contenido/resumenes-gpc' },
      { etiqueta: 'Manual ENARM Plus', ruta: '/contenido/enarm-plus' },
      { etiqueta: 'Temario', ruta: '/contenido/temario' },
    ],
  },
  {
    etiqueta: 'Preguntas',
    icono: FileQuestion,
    seccion: 'preguntas',
    items: [
      { etiqueta: 'Banco de casos', ruta: '/preguntas' },
      { etiqueta: 'Exámenes', ruta: '/preguntas/examenes' },
      { etiqueta: 'Exámenes resueltos', ruta: '/preguntas/resueltos' },
      { etiqueta: 'Reportes de alumnos', ruta: '/preguntas/reportes' },
    ],
  },
  {
    etiqueta: 'Casos con IA',
    icono: Bot,
    seccion: 'ia',
    items: [
      { etiqueta: 'Generar', ruta: '/ia/generar' },
      { etiqueta: 'Revisión', ruta: '/ia/revision' },
    ],
  },
  {
    etiqueta: 'Reportes',
    icono: ClipboardList,
    seccion: 'reportes',
    items: [
      { etiqueta: 'Estadísticas', ruta: '/reportes' },
      { etiqueta: 'Opiniones de alumnos', ruta: '/reportes/opiniones' },
      { etiqueta: 'Protección de contenido', ruta: '/reportes/seguridad' },
    ],
  },
  {
    etiqueta: 'Configuración',
    icono: Settings,
    seccion: 'configuracion',
    items: [
      { etiqueta: 'Proveedores de IA', ruta: '/configuracion/ia' },
      { etiqueta: 'Fechas ENARM', ruta: '/configuracion/fechas-enarm' },
      { etiqueta: 'Catálogos', ruta: '/configuracion/catalogos' },
      { etiqueta: 'Herramientas', ruta: '/configuracion/herramientas' },
    ],
  },
  {
    etiqueta: 'Staff',
    icono: ShieldCheck,
    seccion: 'staff',
    items: [
      { etiqueta: 'Usuarios staff', ruta: '/staff' },
      { etiqueta: 'Auditoría', ruta: '/staff/auditoria' },
    ],
  },
];
